import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function ProductDetail() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'es' ? 'en' : 'es';
    i18n.changeLanguage(newLang);
  };

  // Producto de ejemplo - Newlong DS-2
  const product = {
    id: 1,
    name: 'Newlong DS-2',
    category: 'Cerradora Industrial',
    brand: 'Newlong',
    origin: 'Japón',
    images: [
      'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/d24718cf39c4e65225bf8ddfdc88b492.png',
      'https://public.readdy.ai/ai/img_res/4d8afbe740abbfbda8b43f3a2e22cb78.jpg',
      'https://readdy.ai/api/search-image?query=Newlong%20DS-2%20industrial%20bag%20closing%20machine%20detail%20close%20up%20mechanism%20parts%20Japanese%20precision%20engineering%20white%20background&width=600&height=600&seq=ds2-detail&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Newlong%20DS-2%20bag%20closing%20machine%20in%20action%20sewing%20industrial%20sack%20manufacturing%20process%20professional%20setting&width=600&height=600&seq=ds2-action&orientation=squarish'
    ],
    price: 'Consultar',
    stock: 'Disponible',
    description: 'La Newlong DS-2 es la cerradora de sacos portátil más confiable del mercado. Con más de 50 años de historia, esta máquina japonesa combina portabilidad, durabilidad y precisión en un diseño compacto. Ideal para operaciones de cerrado de sacos en industrias agrícolas, alimenticias y de manufactura.',
    features: [
      'Portátil y liviana - Fácil de transportar y operar',
      'Costura de alta calidad con puntada segura',
      'Construcción robusta de acero japonés',
      'Bajo mantenimiento y alta durabilidad',
      'Compatible con diversos tipos de sacos',
      'Mecanismo de tensión ajustable',
      'Fabricado en Japón con estándares de calidad superiores',
      'Ideal para sacos de 25kg a 100kg'
    ],
    specifications: [
      { label: 'Peso', value: '3.2 kg' },
      { label: 'Velocidad', value: '1,800 puntadas/min' },
      { label: 'Tipo de puntada', value: 'Cadeneta simple' },
      { label: 'Ancho de costura', value: '6-8 mm' },
      { label: 'Material', value: 'Acero japonés' },
      { label: 'Garantía', value: '12 meses' },
      { label: 'Origen', value: 'Japón' },
      { label: 'Modelo', value: 'DS-2' }
    ],
    applications: [
      'Cerrado de sacos de granos y cereales',
      'Empaque de productos agrícolas',
      'Industria alimenticia',
      'Manufactura textil',
      'Logística y distribución'
    ],
    relatedProducts: [
      {
        id: 2,
        name: 'Newlong DS-2II',
        image: 'https://public.readdy.ai/ai/img_res/b83c8a1f-a62a-47a8-92ad-02552e4c3258.png',
        category: 'Cerradora Industrial'
      },
      {
        id: 3,
        name: 'Newlong DS-2W',
        image: 'https://public.readdy.ai/ai/img_res/dad99827-5469-4e52-a7b6-6ba2f8d1ce8b.png',
        category: 'Cerradora Industrial'
      },
      {
        id: 46,
        name: 'Agujas Organ para Cerradoras',
        image: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/4398eeed7803feff83274692d1ad0c9c.webp',
        category: 'Accesorios'
      },
      {
        id: 39,
        name: 'Hilo Poliéster Industrial 5000m',
        image: 'https://readdy.ai/api/search-image?query=industrial%20polyester%20thread%20large%20spools%205000%20meters%20high%20strength%20various%20colors%20professional%20packaging%20product%20photo%20white%20background&width=400&height=300&seq=polyester-thread-5000m-v2&orientation=landscape',
        category: 'Consumibles'
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-lg border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
              <img 
                src="https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/d03d7dd558dd59549242c09cb047b58f.png" 
                alt="IKIGAI Global Group Inc." 
                className="h-14 w-auto"
              />
            </div>
            
            {/* Desktop Navigation */}
            <nav className="hidden lg:flex space-x-10 items-center">
              <a href="/#inicio" className="text-gray-700 hover:text-blue-600 cursor-pointer whitespace-nowrap font-medium text-sm uppercase tracking-wide transition-colors">{t('nav.home', 'Inicio')}</a>
              <a href="/#productos" className="text-gray-700 hover:text-blue-600 cursor-pointer whitespace-nowrap font-medium text-sm uppercase tracking-wide transition-colors">{t('nav.products', 'Productos')}</a>
              <a href="/#marcas" className="text-gray-700 hover:text-blue-600 cursor-pointer whitespace-nowrap font-medium text-sm uppercase tracking-wide transition-colors">{t('nav.brands', 'Marcas')}</a>
              <a href="/#servicios" className="text-gray-700 hover:text-blue-600 cursor-pointer whitespace-nowrap font-medium text-sm uppercase tracking-wide transition-colors">{t('nav.services', 'Servicios')}</a>
              <a href="/#contacto" className="text-gray-700 hover:text-blue-600 cursor-pointer whitespace-nowrap font-medium text-sm uppercase tracking-wide transition-colors">{t('nav.contact', 'Contacto')}</a>
              
              <button 
                onClick={toggleLanguage}
                className="flex items-center space-x-2 px-4 py-2 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors"
              >
                <i className="ri-global-line text-gray-600"></i>
                <span className="text-sm font-medium text-gray-700">
                  {i18n.language === 'es' ? 'EN' : 'ES'}
                </span>
              </button>

              <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition-colors whitespace-nowrap text-sm">
                Cotización Gratuita
              </button>
            </nav>

            {/* Mobile menu button */}
            <button 
              className="lg:hidden p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className="ri-menu-line text-xl text-gray-700"></i>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="lg:hidden py-4 border-t border-gray-200">
              <nav className="flex flex-col space-y-2">
                <a href="/#inicio" className="text-gray-700 hover:text-blue-600 cursor-pointer py-2 font-medium">{t('nav.home', 'Inicio')}</a>
                <a href="/#productos" className="text-gray-700 hover:text-blue-600 cursor-pointer py-2 font-medium">{t('nav.products', 'Productos')}</a>
                <a href="/#marcas" className="text-gray-700 hover:text-blue-600 cursor-pointer py-2 font-medium">{t('nav.brands', 'Marcas')}</a>
                <a href="/#servicios" className="text-gray-700 hover:text-blue-600 cursor-pointer py-2 font-medium">{t('nav.services', 'Servicios')}</a>
                <a href="/#contacto" className="text-gray-700 hover:text-blue-600 cursor-pointer py-2 font-medium">{t('nav.contact', 'Contacto')}</a>
                <button 
                  onClick={toggleLanguage}
                  className="flex items-center space-x-2 px-3 py-2 text-left"
                >
                  <i className="ri-global-line text-gray-600"></i>
                  <span className="text-sm font-medium text-gray-700">
                    {i18n.language === 'es' ? 'English' : 'Español'}
                  </span>
                </button>
                <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition-colors whitespace-nowrap text-sm mt-4">
                  Cotización Gratuita
                </button>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Breadcrumb */}
      <div className="bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center space-x-2 text-sm">
            <a href="/" className="text-gray-500 hover:text-blue-600 cursor-pointer">Inicio</a>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <a href="/#productos" className="text-gray-500 hover:text-blue-600 cursor-pointer">Productos</a>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-900 font-medium">{product.name}</span>
          </div>
        </div>
      </div>

      {/* Product Detail */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Image Gallery */}
            <div>
              <div className="bg-gray-50 rounded-2xl p-8 mb-6 border border-gray-200">
                <div className="w-full h-96">
                  <img 
                    src={product.images[selectedImage]} 
                    alt={product.name}
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
              <div className="grid grid-cols-4 gap-4">
                {product.images.map((image, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedImage(index)}
                    className={`bg-gray-50 rounded-lg p-3 border-2 transition-all hover:border-blue-400 ${
                      selectedImage === index ? 'border-blue-600' : 'border-gray-200'
                    }`}
                  >
                    <div className="w-full h-20">
                      <img 
                        src={image} 
                        alt={`${product.name} - Vista ${index + 1}`}
                        className="w-full h-full object-contain"
                      />
                    </div>
                  </button>
                ))}
              </div>
            </div>

            {/* Product Info */}
            <div>
              <div className="mb-6">
                <div className="flex items-center space-x-3 mb-4">
                  <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-semibold">
                    {product.category}
                  </span>
                  <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-semibold">
                    {product.stock}
                  </span>
                </div>
                <h1 className="text-4xl font-bold text-gray-900 mb-4">{product.name}</h1>
                <div className="flex items-center space-x-4 text-gray-600 mb-6">
                  <div className="flex items-center">
                    <i className="ri-building-line mr-2"></i>
                    <span className="font-medium">{product.brand}</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-map-pin-line mr-2"></i>
                    <span className="font-medium">{product.origin}</span>
                  </div>
                </div>
              </div>

              <div className="mb-8">
                <p className="text-gray-700 text-lg leading-relaxed">{product.description}</p>
              </div>

              {/* Price and Quantity */}
              <div className="bg-gray-50 rounded-2xl p-8 mb-8 border border-gray-200">
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <p className="text-sm text-gray-600 mb-1">Precio</p>
                    <p className="text-3xl font-bold text-blue-600">{product.price}</p>
                  </div>
                  <div className="flex items-center space-x-4">
                    <button 
                      onClick={() => setQuantity(Math.max(1, quantity - 1))}
                      className="w-10 h-10 bg-white border-2 border-gray-300 rounded-lg flex items-center justify-center hover:border-blue-600 transition-colors"
                    >
                      <i className="ri-subtract-line text-gray-700"></i>
                    </button>
                    <span className="text-2xl font-bold text-gray-900 w-12 text-center">{quantity}</span>
                    <button 
                      onClick={() => setQuantity(quantity + 1)}
                      className="w-10 h-10 bg-white border-2 border-gray-300 rounded-lg flex items-center justify-center hover:border-blue-600 transition-colors"
                    >
                      <i className="ri-add-line text-gray-700"></i>
                    </button>
                  </div>
                </div>
                <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-4 px-6 rounded-lg font-bold transition-all whitespace-nowrap text-lg hover:shadow-lg mb-3">
                  <i className="ri-shopping-cart-line mr-2"></i>
                  Solicitar Cotización
                </button>
                <button className="w-full bg-white hover:bg-gray-50 text-gray-900 py-4 px-6 rounded-lg font-bold transition-all whitespace-nowrap text-lg border-2 border-gray-300">
                  <i className="ri-phone-line mr-2"></i>
                  Contactar Asesor
                </button>
              </div>

              {/* Features */}
              <div className="mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Características Principales</h3>
                <ul className="space-y-3">
                  {product.features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <i className="ri-check-line text-green-500 mr-3 text-xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Specifications */}
          <div className="mt-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-8">Especificaciones Técnicas</h3>
            <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {product.specifications.map((spec, index) => (
                  <div key={index} className="bg-white rounded-lg p-6 border border-gray-200">
                    <p className="text-sm text-gray-600 mb-2">{spec.label}</p>
                    <p className="text-lg font-bold text-gray-900">{spec.value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Applications */}
          <div className="mt-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-8">Aplicaciones Industriales</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {product.applications.map((application, index) => (
                <div key={index} className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-blue-400 transition-all">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-checkbox-circle-line text-blue-600 text-xl"></i>
                    </div>
                    <p className="text-gray-900 font-medium">{application}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Related Products */}
          <div className="mt-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-8">Productos Relacionados</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {product.relatedProducts.map((relatedProduct) => (
                <div key={relatedProduct.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all border border-gray-100 hover:border-blue-200 transform hover:-translate-y-2 cursor-pointer">
                  <div className="relative">
                    <div className="w-full h-64">
                      <img 
                        src={relatedProduct.image} 
                        alt={relatedProduct.name}
                        className="w-full h-full object-contain object-center p-4 bg-gray-50"
                      />
                    </div>
                  </div>
                  <div className="p-6">
                    <p className="text-sm text-gray-600 mb-2">{relatedProduct.category}</p>
                    <h4 className="text-lg font-bold text-gray-900 mb-4">{relatedProduct.name}</h4>
                    <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg font-semibold transition-all whitespace-nowrap text-sm">
                      Ver Detalles
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            <div className="md:col-span-2">
              <img 
                src="https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/d03d7dd558dd59549242c09cb047b58f.png" 
                alt="IKIGAI Global Group Inc." 
                className="h-12 w-auto mb-6"
              />
              <p className="text-gray-400 text-lg leading-relaxed mb-6">
                Distribución directa de fábrica de maquinaria industrial para coser sacos y repuestos originales. 
                Su socio estratégico en equipos industriales de alta calidad desde Miami hacia toda Latinoamérica.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 cursor-pointer transition-colors">
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
                <a href="#" className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 cursor-pointer transition-colors">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 cursor-pointer transition-colors">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-xl font-bold mb-6">Productos</h4>
              <ul className="space-y-3 text-gray-400">
                <li><a href="/#productos" className="hover:text-white cursor-pointer transition-colors">Cerradoras Newlong</a></li>
                <li><a href="/#productos" className="hover:text-white cursor-pointer transition-colors">Cosedoras Industriales</a></li>
                <li><a href="/#productos" className="hover:text-white cursor-pointer transition-colors">Máquinas Union Special</a></li>
                <li><a href="/#productos" className="hover:text-white cursor-pointer transition-colors">Repuestos Originales</a></li>
                <li><a href="/#productos" className="hover:text-white cursor-pointer transition-colors">Accesorios</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-xl font-bold mb-6">Servicios</h4>
              <ul className="space-y-3 text-gray-400">
                <li><a href="/#servicios" className="hover:text-white cursor-pointer transition-colors">Asesoría Especializada</a></li>
                <li><a href="/#servicios" className="hover:text-white cursor-pointer transition-colors">Consultoría</a></li>
                <li><a href="/#servicios" className="hover:text-white cursor-pointer transition-colors">Mantenimiento</a></li>
                <li><a href="/#servicios" className="hover:text-white cursor-pointer transition-colors">Capacitación</a></li>
                <li><a href="/#servicios" className="hover:text-white cursor-pointer transition-colors">Logística</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-400">
            <p>&copy; 2024 IKIGAI Global Group Inc. Todos los derechos reservados.</p>
            <a href="https://readdy.ai/?ref=logo" className="hover:text-white transition-colors mt-4 md:mt-0">Website Builder</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
